import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GridOptionFieldsFragment = {
  id: string;
  name: string;
  values: Array<{ id: string; name: string; option: { id: string; name: string } }>;
};

export type GridOptionsQueryVariables = Types.Exact<{
  orderby?: Types.InputMaybe<
    Array<Types.InputMaybe<Types.Scalars['String']>> | Types.InputMaybe<Types.Scalars['String']>
  >;
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  before?: Types.InputMaybe<Types.Scalars['String']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
  name?: Types.InputMaybe<Types.Scalars['String']>;
  name_Iexact?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type GridOptionsQuery = {
  gridOptions?: {
    totalCount?: number | null;
    edges: Array<{
      node?: {
        id: string;
        name: string;
        values: Array<{ id: string; name: string; option: { id: string; name: string } }>;
      } | null;
    } | null>;
  } | null;
};

export const GridOptionFieldsFragmentDoc = gql`
  fragment gridOptionFields on GridOptionType {
    id
    name
    values {
      id
      name
      option {
        id
        name
      }
    }
  }
`;
export const GridOptionsDocument = gql`
  query GridOptions(
    $orderby: [String]
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $name: String
    $name_Iexact: String
  ) {
    gridOptions(
      orderby: $orderby
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      name: $name
      name_Iexact: $name_Iexact
    ) {
      totalCount
      edges {
        node {
          ...gridOptionFields
        }
      }
    }
  }
  ${GridOptionFieldsFragmentDoc}
`;

/**
 * __useGridOptionsQuery__
 *
 * To run a query within a React component, call `useGridOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGridOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGridOptionsQuery({
 *   variables: {
 *      orderby: // value for 'orderby'
 *      offset: // value for 'offset'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      name: // value for 'name'
 *      name_Iexact: // value for 'name_Iexact'
 *   },
 * });
 */
export function useGridOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GridOptionsQuery, GridOptionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GridOptionsQuery, GridOptionsQueryVariables>(GridOptionsDocument, options);
}
export function useGridOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GridOptionsQuery, GridOptionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GridOptionsQuery, GridOptionsQueryVariables>(
    GridOptionsDocument,
    options,
  );
}
export type GridOptionsQueryHookResult = ReturnType<typeof useGridOptionsQuery>;
export type GridOptionsLazyQueryHookResult = ReturnType<typeof useGridOptionsLazyQuery>;
export type GridOptionsQueryResult = Apollo.QueryResult<
  GridOptionsQuery,
  GridOptionsQueryVariables
>;
